import { EPlatform, IClientConfig } from '@mm-frontend/clickstream-client-js';

import package_json from '../../../package.json';

const URL = process.env.NODE_ENV === 'production'
  ? 'https://events-business.kazanexpress.ru/events'
  : 'https://clickstream-b2b.dev.cluster.kznexpess.com/events';

const DEBOUNCE_TIME = 1000;

const clickstreamConfig: IClientConfig = {
  deviceProperties: {
    platform: EPlatform.WEB,
  },
  userProperties: {
    googleCid: '',
    myTrackerLvid: '',
    yaMetricaId: '',
    muid: '',
    language: 'ru',
  },
  appProperties: {
    packageName: package_json.name,
    appVersion: package_json.version,
  },
  eventsDebounceTime: DEBOUNCE_TIME,
  clickstreamUrl: URL,
  accessToken: '',
};

export { clickstreamConfig };
